import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";
import styles from "./Login.module.css";

export const Login: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const { t } = useTranslation();

  const handleLogin = async () => {
    try {
      await loginWithRedirect();
    } catch (err) {
      console.error("Auth0 login error:", err);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginContent}>
        <button onClick={handleLogin} className={styles.loginButton}>
          {t('login.button')}
        </button>
      </div>
    </div>
  );
};

